import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
const plugins = [createPersistedState()];

export default new Vuex.Store({
    plugins,
    state:{
        token: null,
        tab_menu: null,
        userProfile:null,
        monthList:[
            {
                id:1,
                name:'มกราคม',
                name_short:'ม.ค.',
                name_en:'January',
                name_en_short:'Jan',
            },
            {
                id:2,
                name:'กุมภาพันธ์',
                name_short:'ก.พ.',
                name_en:'February',
                name_en_short:'Feb',
            },
            {
                id:3,
                name:'มีนาคม',
                name_short:'มี.ค.',
                name_en:'March',
                name_en_short:'Mar',
            },
            {
                id:4,
                name:'เมษายน',
                name_short:'เม.ย.',
                name_en:'April',
                name_en_short:'Apr',
            },
            {
                id:5,
                name:'พฤษภาคม',
                name_short:'พ.ค.',
                name_en:'May',
                name_en_short:'May',
            },
            {
                id:6,
                name:'มิถุนายน',
                name_short:'มิ.ย.',
                name_en:'June',
                name_en_short:'Jun',
            },
            {
                id:7,
                name:'กรกฎาคม',
                name_short:'ก.ค.',
                name_en:'July',
                name_en_short:'Jul',
            },
            {
                id:8,
                name:'สิงหาคม',
                name_short:'ส.ค.',
                name_en:'August',
                name_en_short:'Aug',
            },
            {
                id:9,
                name:'กันยายน',
                name_short:'ก.ย.',
                name_en:'September',
                name_en_short:'Sep',
            },
            {
                id:10,
                name:'ตุลาคม',
                name_short:'ต.ค.',
                name_en:'October',
                name_en_short:'Oct',
            },
            {
                id:11,
                name:'พฤศจิกายน',
                name_short:'พ.ย.',
                name_en:'November',
                name_en_short:'Nov',
            },
            {
                id:12,
                name:'ธันวาคม',
                name_short:'ธ.ค.',
                name_en:'December',
                name_en_short:'Dec',
            },
          ],
        editTeamId:null,
        detailReportWorkDate:null,
        editReportWorkDate:null,
        detailPartTimeSummaryId:null,
        editPartTimeSummaryId:null,
        detailEmployeeSummaryId:null,
        editEmployeeSummaryId:null,
        timeHoursWorkedList:[
            '00:00:00',
            '00:30:00',
            '01:00:00',
            '01:30:00',
            '02:00:00',
            '02:30:00',
            '03:00:00',
            '03:30:00',
            '04:00:00',
            '04:30:00',
            '05:00:00',
            '05:30:00',
            '06:00:00',
            '06:30:00',
            '07:00:00',
            '07:30:00',
            '08:00:00',
            '08:30:00',
            '09:00:00',
            '09:30:00',
            '10:00:00',
            '10:30:00',
            '11:00:00',
            '11:30:00',
            '12:00:00',
            '12:30:00',
            '13:00:00',
            '13:30:00',
            '14:00:00',
            '14:30:00',
            '15:00:00',
            '15:30:00',
            '16:00:00',
            '16:30:00',
            '17:00:00',
            '17:30:00',
            '18:00:00',
            '18:30:00',
            '19:00:00',
            '19:30:00',
            '20:00:00',
            '20:30:00',
            '21:00:00',
            '21:30:00',
            '22:00:00',
            '22:30:00',
            '23:00:00',
            '23:30:00',
        ],
        tokenQuickFoodOrder:null,
        invoiceQuickFoodOrderId:null,
        detailTableId:null,
        detailFoodId:null,
        detailToppingId:null,
        detailPaymentTakeOutAdminId:null,
        checkEmoji:/[^a-z|A-Z|0-9|ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ| |*|+|/|.|-]/g,
        cartTakeOutNameUser:null,
        cartIdListUser:1,
        cartListUser:[],

        cartOrderOnlineNameUser:null,
        cartIdListUserOrderOnline:1,
        cartListUserOrderOnline:[],

        cartTakeOutTableId:null,
        cartIdListTakeOutTable:1,
        cartListTakeOutTable:[],
        cartIdListUserTakeOut:1,
        cartListUserTakeOut:[],
        checkAdvertise:true,
        checkAdvertiseDate:null,
        checkAdvertiseType:null,
        //เหตุผลในการยกเลิกบิล
        reasonCancelBill:['เพิ่มรายการผิด','ยกเลิกรายการ','คืนสินค้า','อื่นๆ'],
        unitTypeList:[
            {
                id: 1,
                name: 'กรัม'
            },
            {
                id: 2,
                name: 'กิโลกรัม'
            },
        ],
        addLotinId:null,
        lotDetailInId:null,
        lotDetailInEditId:null,
        lotDetailOutId:null,
        lotDetailOutEditId:null,
        purchaseOrderNewDetailId:null,
        timeOrderOnlinepickUpList:[
            '17:00:00',
            '17:30:00',
            '18:00:00',
            '18:30:00',
            '19:00:00',
            '19:30:00',
            '20:00:00',
            '20:30:00',
            '21:00:00',
            '21:30:00',
            '22:00:00',
            '22:30:00',
        ],
        editorOption: {
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                    ['blockquote', 'code-block'],

                    [{
                        'header': 1
                    }, {
                        'header': 2
                    }], // custom button values
                    [{
                        'list': 'ordered'
                    }, {
                        'list': 'bullet'
                    }],
                    [{
                        'script': 'sub'
                    }, {
                        'script': 'super'
                    }], // superscript/subscript
                    [{
                        'indent': '-1'
                    }, {
                        'indent': '+1'
                    }], // outdent/indent
                    [{
                        'direction': 'rtl'
                    }], // text direction

                    [{
                        'size': ['small', false, 'large', 'huge']
                    }], // custom dropdown
                    [{
                        'header': [1, 2, 3, 4, 5, 6, false]
                    }],

                    [{
                        'color': []
                    }, {
                        'background': []
                    }], // dropdown with defaults from theme
                    [{
                        'font': []
                    }],
                    [{
                        'align': []
                    }],

                    ['clean'],
                    ['link', 'image', 'video']
                ],
                imageDrop: true,
                imageResize: true,
            },
        },
        detailContentOrderId:null,
        detailContentRetrospectId:null,
        detailBlogId:null,
        detailCloseRetrospectId:null,
        quickFoodStatus: null,
    },
    mutations:{
        logInSuccess(state,data){
            state.token = data.token
        },
        logOutSuccess(state){
            state.token = null
        },
        userProfileSuccess(state,data){
            state.userProfile = data
        },
        clearCheckEmoji(state){
            state.checkEmoji = /[^a-z|A-Z|0-9|ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ| |*|+|/|.|-]/g
        },
        clearMonthList(state){
            state.monthList = [
                {
                    id:1,
                    name:'มกราคม',
                    name_short:'ม.ค.',
                    name_en:'January',
                    name_en_short:'Jan',
                },
                {
                    id:2,
                    name:'กุมภาพันธ์',
                    name_short:'ก.พ.',
                    name_en:'February',
                    name_en_short:'Feb',
                },
                {
                    id:3,
                    name:'มีนาคม',
                    name_short:'มี.ค.',
                    name_en:'March',
                    name_en_short:'Mar',
                },
                {
                    id:4,
                    name:'เมษายน',
                    name_short:'เม.ย.',
                    name_en:'April',
                    name_en_short:'Apr',
                },
                {
                    id:5,
                    name:'พฤษภาคม',
                    name_short:'พ.ค.',
                    name_en:'May',
                    name_en_short:'May',
                },
                {
                    id:6,
                    name:'มิถุนายน',
                    name_short:'มิ.ย.',
                    name_en:'June',
                    name_en_short:'Jun',
                },
                {
                    id:7,
                    name:'กรกฎาคม',
                    name_short:'ก.ค.',
                    name_en:'July',
                    name_en_short:'Jul',
                },
                {
                    id:8,
                    name:'สิงหาคม',
                    name_short:'ส.ค.',
                    name_en:'August',
                    name_en_short:'Aug',
                },
                {
                    id:9,
                    name:'กันยายน',
                    name_short:'ก.ย.',
                    name_en:'September',
                    name_en_short:'Sep',
                },
                {
                    id:10,
                    name:'ตุลาคม',
                    name_short:'ต.ค.',
                    name_en:'October',
                    name_en_short:'Oct',
                },
                {
                    id:11,
                    name:'พฤศจิกายน',
                    name_short:'พ.ย.',
                    name_en:'November',
                    name_en_short:'Nov',
                },
                {
                    id:12,
                    name:'ธันวาคม',
                    name_short:'ธ.ค.',
                    name_en:'December',
                    name_en_short:'Dec',
                },
              ]
        },
        setTabMenu(state,data){
            state.tab_menu = data.name
        },
        editTeamPage(state,data){
            state.editTeamId = data.id
        },
        detailReportWorkPage(state,data){
            state.detailReportWorkDate = data.date
        },
        editReportWorkPage(state,data){
            state.editReportWorkDate = data.date
        },
        detailPartTimeSummaryPage(state,data){
            state.detailPartTimeSummaryId = data.id
        },
        editPartTimeSummaryPage(state,data){
            state.editPartTimeSummaryId = data.id
        },
        detailEmployeeSummaryPage(state,data){
            state.detailEmployeeSummaryId = data.id
        },
        editEmployeeSummaryPage(state,data){
            state.editEmployeeSummaryId = data.id
        },
        tokenQuickFoodOrderPage(state,data){
            state.tokenQuickFoodOrder = data.token
        },
        invoiceQuickFoodOrderPage(state,data){
            state.invoiceQuickFoodOrderId = data.id
        },
        detailTablePage(state,data){
            state.detailTableId = data.id
        },
        quickFoodStatus(state, data) {
            state.quickFoodStatus = data
        },
        addLotinPage(state,data){
            state.addLotinId = data.id
        },
        lotDetailInPage(state,data){
            state.lotDetailInId = data.id
        },
        lotDetailInEditPage(state,data){
            state.lotDetailInEditId = data.id
        },
        lotDetailOutPage(state,data){
            state.lotDetailOutId = data.id
        },
        lotDetailOutEditPage(state,data){
            state.lotDetailOutEditId = data.id
        },
        purchaseOrderNewDetailPage(state,data){
            state.purchaseOrderNewDetailId = data.id
        },
        clearPurchaseOrderNewDetailPage(state){
            state.purchaseOrderNewDetailId = null
        },
        clearTokenQuickFoodOrderPage(state){
            state.tokenQuickFoodOrder = null
        },
        clearInvoiceQuickFoodOrderPage(state){
            state.invoiceQuickFoodOrderId = null
        },
        clearTablePage(state){
            state.detailTableId = null
        },
        detailPaymentTakeOutAdminPage(state,data){
            state.detailPaymentTakeOutAdminId = data.id
        },
        detailFoodPage(state,data){
            state.detailFoodId = data.id
        },
        detailToppingPage(state,data){
            state.detailToppingId = data.id
        },
        detailContentOrderPage(state,data){
            state.detailContentOrderId = data.id
        },
        detailContentRetrospectPage(state,data){
            state.detailContentRetrospectId = data.id
        },
        detailBlogPage(state,data){
            state.detailBlogId = data.id
        },
        addCartTakeOutNameUser(state,data){
            state.cartTakeOutNameUser = data.name
        },
        addCartOrderOnlineNameUser(state,data){
            state.cartOrderOnlineNameUser = data
        },
        //ลูกค้า เปิดโต๊ะ
        addCartListUser(state,data){
            state.cartListUser.push({
                id: state.cartIdListUser,
                foodmenu_id: data.foodmenu_id,
                name: data.name,
                amount: data.amount,
                price: parseInt(data.price),
                total_price: data.total_price,
                toping_id: data.toping_id,
                topping_name: data.topping_name,
                amount_topping: data.amount_topping,
                toppingprice: data.toppingprice,
                toppingprice_list: data.toppingprice_list,
                topping_arr_list: data.topping_arr_list,
                description:data.description,
                type:data.type,
            })
            state.cartIdListUser += 1

        },
        editCartListUser(state,data){
            let cart = state.cartListUser.find((detail) => {
                return detail.id == data.id
            })
            cart.foodmenu_id = data.foodmenu_id
            cart.name = data.name
            cart.amount = data.amount
            cart.price = parseInt(data.price)
            cart.total_price = data.total_price
            cart.toping_id = data.toping_id
            cart.topping_name = data.topping_name
            cart.amount_topping = data.amount_topping
            cart.toppingprice = data.toppingprice
            cart.toppingprice_list = data.toppingprice_list
            cart.topping_arr_list = data.topping_arr_list
            cart.description = data.description
            cart.type = data.type
        },
        deleteCartListUser(state,data){
            state.cartListUser = state.cartListUser.filter(detail => detail.id !== data.id)
        },
        clearCartListUser(state){
            state.cartIdListUser = 1
            state.cartListUser = []
        },
        //ลูกค้า ซื้อกลับบ้าน แต่เปิดโต๊ะ
        detailTakeOutTablePage(state,data){
            state.cartTakeOutTableId = data.id
        },
        addCartTakeOutTableListUser(state,data){
            state.cartListTakeOutTable.push({
                id: state.cartIdListTakeOutTable,
                foodmenu_id: data.foodmenu_id,
                name: data.name,
                amount: data.amount,
                price: parseInt(data.price),
                total_price: data.total_price,
                toping_id: data.toping_id,
                topping_name: data.topping_name,
                amount_topping: data.amount_topping,
                toppingprice: data.toppingprice,
                toppingprice_list: data.toppingprice_list,
                topping_arr_list: data.topping_arr_list,
                description:data.description,
                type:data.type,
            })
            state.cartIdListTakeOutTable += 1
        },
        editCartTakeOutTableListUser(state,data){
            let cart = state.cartListTakeOutTable.find((detail) => {
                return detail.id == data.id
            })
            cart.foodmenu_id = data.foodmenu_id
            cart.name = data.name
            cart.amount = data.amount
            cart.price = parseInt(data.price)
            cart.total_price = data.total_price
            cart.toping_id = data.toping_id
            cart.topping_name = data.topping_name
            cart.amount_topping = data.amount_topping
            cart.toppingprice = data.toppingprice
            cart.toppingprice_list = data.toppingprice_list
            cart.topping_arr_list = data.topping_arr_list
            cart.description = data.description
            cart.type = data.type
        },
        deleteCartTakeOutTableListUser(state,data){
            state.cartListTakeOutTable = state.cartListTakeOutTable.filter(detail => detail.id !== data.id)
        },
        clearCartTakeOutTableListUser(state){
            state.cartIdListTakeOutTable = 1
            state.cartListTakeOutTable = []
        },
        //ลูกค้า ซื้อกลับบ้าน
        addCartListUserTakeOut(state,data){
            state.cartListUserTakeOut.push({
                id: state.cartIdListUserTakeOut,
                foodmenu_id: data.foodmenu_id,
                name: data.name,
                amount: data.amount,
                price: parseInt(data.price),
                total_price: data.total_price,
                toping_id: data.toping_id,
                topping_name: data.topping_name,
                amount_topping: data.amount_topping,
                toppingprice: data.toppingprice,
                toppingprice_list: data.toppingprice_list,
                topping_arr_list: data.topping_arr_list,
                description:data.description,
                type:data.type,
            })
            state.cartIdListUserTakeOut += 1

        },
        editCartListUserTakeOut(state,data){
            let cart = state.cartListUserTakeOut.find((detail) => {
                return detail.id == data.id
            })
            cart.foodmenu_id = data.foodmenu_id
            cart.name = data.name
            cart.amount = data.amount
            cart.price = parseInt(data.price)
            cart.total_price = data.total_price
            cart.toping_id = data.toping_id
            cart.topping_name = data.topping_name
            cart.amount_topping = data.amount_topping
            cart.toppingprice = data.toppingprice
            cart.toppingprice_list = data.toppingprice_list
            cart.topping_arr_list = data.topping_arr_list
            cart.description = data.description
            cart.type = data.type
        },
        deleteCartListUserTakeOut(state,data){
            state.cartListUserTakeOut = state.cartListUserTakeOut.filter(detail => detail.id !== data.id)
        },
        clearCartListUserTakeOut(state){
            state.cartTakeOutNameUser = null
            state.cartIdListUserTakeOut = 1
            state.cartListUserTakeOut = []
        },
        //ลูกค้าสั่งผ่านหน้าเว็บ ไปรับเอง
        addCartOrderOnlineUser(state,data){
            state.cartListUserOrderOnline.push({
                id: state.cartIdListUserOrderOnline,
                foodmenu_id: data.foodmenu_id,
                name: data.name,
                amount: data.amount,
                price: parseInt(data.price),
                total_price: data.total_price,
                toping_id: data.toping_id,
                topping_name: data.topping_name,
                amount_topping: data.amount_topping,
                toppingprice: data.toppingprice,
                toppingprice_list: data.toppingprice_list,
                topping_arr_list: data.topping_arr_list,
                description:data.description,
                type:data.type,
            })
            state.cartIdListUserOrderOnline += 1

        },
        editCartOrderOnlineUser(state,data){
            let cart = state.cartListUserOrderOnline.find((detail) => {
                return detail.id == data.id
            })
            cart.foodmenu_id = data.foodmenu_id
            cart.name = data.name
            cart.amount = data.amount
            cart.price = parseInt(data.price)
            cart.total_price = data.total_price
            cart.toping_id = data.toping_id
            cart.topping_name = data.topping_name
            cart.amount_topping = data.amount_topping
            cart.toppingprice = data.toppingprice
            cart.toppingprice_list = data.toppingprice_list
            cart.topping_arr_list = data.topping_arr_list
            cart.description = data.description
            cart.type = data.type
        },
        deleteCartOrderOnlineUser(state,data){
            state.cartListUserOrderOnline = state.cartListUserOrderOnline.filter(detail => detail.id !== data.id)
        },
        clearCartOrderOnlineUser(state){
            state.cartOrderOnlineNameUser = null
            state.cartIdListUserOrderOnline = 1
            state.cartListUserOrderOnline = []
        },
        startAdvertise(state,data){
            state.checkAdvertise = true
            state.checkAdvertiseDate = data.date
            state.checkAdvertiseType = data.type
        },
        closeAdvertise(state){
            state.checkAdvertise = false
        },
        detailCloseRetrospectPage(state,data){
            state.detailCloseRetrospectId = data.id
        },
    }
  })
